import DialogWrapper2 from '../../../../../core/dialog/dialog_wrapper_v2';
import * as React from 'react';
import style from './../../Assistent.less';
import { ZusatztoolsToolExcelImport } from '../../../../zusatztools/ZusatztoolsToolExcelImport';

export interface ImportButtonWrapperProps {
    data: any;
    onRoutingChange: (routing: any) => void;
    standortSelected: any;
    mode?: string;
    onDone?: (jahr: number) => void;
    doneText: string;
}

export interface ImportButtonWrapperState {
    showDialog: boolean;
}

export class ImportButtonWrapper extends React.Component<ImportButtonWrapperProps, ImportButtonWrapperState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showDialog: false,
        };
    }

    render(): JSX.Element {
        return (
            <div style={{ display: 'inline-block' }}>
                <button
                    style={{
                        margin: this.props.mode !== 'small' && 2,
                        marginTop: this.props.mode === 'small' ? 5 :  22,
                        width: this.props.mode === 'small' ? 202 : 662
                    }}
                    className={this.props.mode === 'small' ? style.small : style.basic}
                    onClick={() => this.setState({ showDialog: true })}
                >
                    Import aus Excel
                </button>
                {this.state.showDialog &&
                    <div>
                        <DialogWrapper2
                            width={-1}
                            onAfterClose={() => this.setState({ showDialog: undefined })}
                        >
                            <div style={{ minWidth: 300 }}>
                                <ZusatztoolsToolExcelImport
                                    data={this.props.data}
                                    standortSelected={this.props.standortSelected}
                                    onRoutingChange={this.props.onRoutingChange}
                                    onDone={(jahr: number) => {
                                                this.setState({ showDialog: undefined });
                                                if (this.props.onDone) {
                                                    this.props.onDone(jahr);
                                                }
                                            }
                                        }
                                    doneText={this.props.doneText}
                                />
                            </div>
                        </DialogWrapper2>
                    </div>
                }
            </div>
        );
    }
}
